import { For, type JSX } from 'solid-js'
import type { ThemeOptionScope } from 'mormaii-web-presentation/restricted'

import Css from './theme-choice.module.scss'

/** As tres aparencias do painel, como miniaturas - a escolhida fica marcada. */
export function ThemeChoice(props: { options: ThemeOptionScope[] }): JSX.Element {
    return (
        <div class={Css.choice} role="radiogroup" aria-label="Aparência do painel">
            <For each={props.options}>
                {(option) => (
                    <button
                        type="button"
                        role="radio"
                        aria-checked={option.current}
                        class={Css.tile}
                        classList={{ [Css.current]: option.current }}
                        onClick={() => void option.onSelect()}
                    >
                        <span class={Css.mini} data-preview={option.value.toLowerCase()}>
                            <i />
                            <i />
                            <i />
                        </span>
                        <span>{option.label}</span>
                    </button>
                )}
            </For>
        </div>
    )
}
